import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PhotoLoaderService } from './photo-loader.service';

@NgModule({
    imports: [CommonModule],
    declarations: [],
    providers: [PhotoLoaderService],
    exports: []
})
export class PhotoLoaderModule {}
